import { PagedInviteGridDto } from './../../../../core/models/invite-grid-model';
import { GuardianProxyService } from './../../../../core/services/api/guardian-proxy.service';
import { Component, OnInit, Inject } from '@angular/core';
import { BlockType } from '../../../../core/models/enums/blockType';
import { NotificationType } from '../../../../core/models/enums/notificationType';
import { Invite } from '../../../../core/models/invite-model';
import { Router } from '@angular/router';
import { InviteService } from '../../../../core/services/api/invite.service';
import { IAuthService } from '../../../../core/services/api/contracts/auth-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IWService } from '../../../../core/services/iw.service';
import { BasicModalOperationResult } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { IBasicModalComponentInstance, DialogModalComponent } from '../../../../shared/components/dialog-modal/dialog-modal.component';
import { AuthInterceptor } from '../../../../core/handler/auth-interceptor';
import { DismissReason } from '../../../../shared/extensions/ng-active-modal/dismiss-reason';
import { NewUserComponent } from '../new-user/new-user.component';
import { UserStatus } from '../../../../core/models/enums/userStatus';
import { UserRoles} from '../../../../core/models/enums/userRoles';
import { NotificationService } from '../../../../core/services/api/notification.service';
import { BlockUnblockService } from '../../../../core/services/api/blockunblock.service';
import { SystemAccountAuthModel } from 'src/app/core/models/system-account';
import { Options } from 'src/app/shared/components/pagination/pagination.component';
import { EditUserComponent } from '../edit-user/edit-user/edit-user.component';
import {  OutgoingChatMessageStatusEnum } from 'src/app/core/models/enums/IncomingChatMessageStatusEnum';

@Component({
  selector: 'app-users-grid',
  templateUrl: './users-grid.component.html',
  styleUrls: ['./users-grid.component.scss']
})
export class UsersGridComponent implements OnInit {
  users: Invite[];
  usersGrid: PagedInviteGridDto = new PagedInviteGridDto();
  showSpinner: boolean = true;
  submitting: boolean = false;
  userRoles = UserRoles;
  userStatus = UserStatus;
  notificationType = NotificationType;
  blockUnblockType = BlockType;
  currentUser: SystemAccountAuthModel;  
  options: Options = {
    page: 1,
    size: 10
  };
  isVisible: boolean =false; 
  isUsersGrid: boolean = true;

  constructor(
    private router: Router,
    private inviteService: InviteService,
    @Inject("IAuthService") private authService: IAuthService,
    private modalService: NgbModal,
    public translate: TranslateService,
    public iwService: IWService,
    private notificationService: NotificationService,
    private blockUnblockService: BlockUnblockService,
    private guardianProxyService: GuardianProxyService,
    
  ) { }

  async ngOnInit() {
    this.currentUser = await this.authService.getCurrentProfile();
    await this.loadData(this.options.page, this.options.size);
    this.showSpinner = false;
   
  }

  loadData = async (page?: number, itemsPerPage?: number) => {
    this.usersGrid = await this.inviteService.getUsers(page, itemsPerPage, this.currentUser.organization.id, this.isUsersGrid);
    this.users = this.usersGrid.apiEnabledInvites.items;
  }

  convertDate(dateString: string) {
    var dateStringToBeConverted =
      dateString.replace(/-/g, "/").replace(/T/g, " ") + " UTC";
    let convertedDate = new Date(dateStringToBeConverted);
    return convertedDate;
  }

  async addNewUser() {
    const modalRef = this.modalService.open(NewUserComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "lg",
    });

    var result = await modalRef.result;
    if (result == DismissReason.Saved) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }

    if (result == DismissReason.Cancelled) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }
  }

  shouldNotificationOptionBeShown(userInvite: Invite) {
    return (
      userInvite.currentStatus != this.userStatus.Registered &&
      userInvite.currentStatus != this.userStatus.Blocked &&
      userInvite.currentStatus != this.userStatus.ToBeConfirmed &&
      !userInvite.isCurrentUser
    );
  }

  isNotificationDisabled(userInvite: Invite) {
    return userInvite.currentStatus != this.userStatus.Notified;
  }

  async notifyUsers() {
    let notifiableInvites = this.users.filter(
      (x) => x.shouldBeNotified == true
    );

    const inviteIds = notifiableInvites
      .map((userInvite) => userInvite.inviteId)
      .join(",");    

    try {
      this.showSpinner = true;
      this.submitting = true;
      await this.notificationService.notify(
        inviteIds,
        Number(this.notificationType.User)
      );

      this.showSpinner = false;
      this.submitting = false;
      await this.showSuccessfulNotifyMessage();
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    } catch (error) {
      this.showSpinner = false;
      this.submitting = false;
      const modalInstance = this.modalService.open(DialogModalComponent)
        .componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = this.translate.instant("usersModule.notificationError");
      modalInstance.type = BasicModalOperationResult.Error;
      this.showSpinner = false;
    }
  }

  async isAnyBlockUnblockSignatureInProgress(
    inviteId: Number,
    maxRetries: number = 10,
    msRefreshTime: number = 5000,
    retry: number = 0
  ) {
    if (retry < maxRetries) {
      setTimeout(async () => {
        let currentInviteIndex = this.usersGrid.apiEnabledInvites.items.findIndex(
          (obj) => obj.inviteId == inviteId
        );
        let currentInvite = this.usersGrid.apiEnabledInvites.items.filter(
          (x) => x.inviteId == inviteId
        )[0];
        currentInvite = await this.inviteService.getInviteDetails(inviteId);
        this.usersGrid.apiEnabledInvites.items[currentInviteIndex] = currentInvite;

        if (currentInvite.blockUnblockSignatureInProgress) {
          setTimeout(() => {
            this.isAnyBlockUnblockSignatureInProgress(
              inviteId,
              maxRetries,
              msRefreshTime,
              retry++
            );
          }, msRefreshTime);
        }
      }, msRefreshTime);
    }
  }

  async showSuccessfulNotifyMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.notifiedUsersTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.notifiedUsersBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  isPossibleToNotify() {
    if (!this.users) return false;

    let notifiableInvites = this.users.filter(
      (x) => x.shouldBeNotified == true && x.isCurrentUser == false
    );
    return notifiableInvites && notifiableInvites.length > 0;
  }

  shouldEliminateUserOptionBeShown(userInvite: Invite) {
    return (
      userInvite.currentStatus == this.userStatus.Pending &&
      !userInvite.isCurrentUser
    );
  }

  shouldBlockUnblockUserOptionBeShown(userInvite: Invite) {
    return (
      (userInvite.currentStatus == this.userStatus.Registered ||
        userInvite.currentStatus == this.userStatus.Blocked) &&
      !userInvite.isCurrentUser
    );
  }

  async removeUser(userInvite: Invite) {
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.eliminateUserTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.eliminateUserBody",
      { UserFullName: userInvite.fullName }
    );
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          await this.inviteService.delete(userInvite.inviteId);
          this.showSpinner = true;
          await this.loadData(this.options.page, this.options.size);
          this.showSpinner = false;
        },
      },
    ];
  }

  async blockUnblockUser(userInvite: Invite) {
    if (userInvite.blockUnblockSignatureInProgress) return false;    

    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserTitle")
      : this.translate.instant("usersModule.blockUserTitle");
    modalInstance.body = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserBody", {
        UserFullName: userInvite.fullName,
      })
      : this.translate.instant("usersModule.blockUserBody", {
        UserFullName: userInvite.fullName,
      });
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          try {
            this.showSpinner = true;
            this.submitting = true;
            let response= await this.blockUnblockService.amiSignProcessBlockUnblockInvite(userInvite);
            //TODO= Pasar el CONFIRMED/ERROR A ENUM OUTCOMING
            if(response == OutgoingChatMessageStatusEnum.CONFIRMED)
            {
              let blockUnblockResponse =
              await this.blockUnblockService.blockUnblockInvite(
                userInvite.inviteId,
                Number(this.blockUnblockType.User),
                !userInvite.isBlocked
              );

              await this.blockUnblockService.updateSignProcessBlockUnblockInvite(
                blockUnblockResponse.inviteId
              );
              this.showSpinner = false;
              this.submitting = false;
              await this.showSuccessfulBlockUnBlockMessage(userInvite);
              await this.isAnyBlockUnblockSignatureInProgress(userInvite.inviteId);
              this.showSpinner = true;

            }
            else if (response == OutgoingChatMessageStatusEnum.ERROR) {
              this.submitting = false;
          }   
          await this.loadData(this.options.page, this.options.size);
          this.showSpinner = false;
            
          } catch (error) {
            alert(this.translate.instant("signatureErrorMessage"));
            this.showSpinner = false;
            this.submitting = false;            
          }
        },
      },
    ];
  }

  async showSuccessfulBlockUnBlockMessage(userInvite: Invite) {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.body = userInvite.isBlocked
      ? this.translate.instant("usersModule.unBlockUserMessage", {
        UserFullName: userInvite.fullName,
      })
      : this.translate.instant("usersModule.blockUserMessage", {
        UserFullName: userInvite.fullName,
      });
    modalInstance.title = this.translate.instant("userUpdated");
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  blockUnblockMessageTooltipTitle(userInvite: Invite) {
    let message = "";
    if (userInvite.blockUnblockSignatureInProgress) {
      message = this.translate.instant("blockUnblockSignatureInProcess");
      return message;
    }

    message =
      userInvite.currentStatus == this.userStatus.Blocked
        ? this.translate.instant(
          "usersModule.unBlockUserTitle"
        )
        : this.translate.instant(
          "usersModule.blockUserTitle"
        );

    return message;
  }

  async confirmUser(userInvite: Invite) {
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.confirmUserTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.confirmUserBody",
      { UserFullName: userInvite.fullName }
    );
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
            try {
              this.showSpinner = true;
              this.submitting = true;
              
              await this.guardianProxyService.extrSignProcessAddAssertion(
                userInvite.userByOrganizationId,
                this.translate.currentLang
              );
        
              this.showSpinner = false;
              this.submitting = false;
              
              await this.showSuccessfulConfirmUserMessage();
              this.showSpinner = true;
              await this.loadData(this.options.page, this.options.size);
              this.showSpinner = false;
        
              
            } catch (error) {
              alert(this.translate.instant("signatureErrorMessage"));
              this.showSpinner = false;
              this.submitting = false;
              window.location.reload();
              
            }
          
            
        },
      },
    ];
  }

  async showSuccessfulConfirmUserMessage() {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "usersModule.confirmUserInProgressTitle"
    );
    modalInstance.body = this.translate.instant(
      "usersModule.confirmUserInProgressBody"
    );
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  async isConfirmUserIWSignatureInProgress(
    inviteId: Number,
    maxRetries: number = 10,
    msRefreshTime: number = 5000,
    retry: number = 0
  ) {
    if (retry < maxRetries) {
      setTimeout(async () => {
        let currentInviteIndex = this.usersGrid.apiEnabledInvites.items.findIndex(
          (obj) => obj.inviteId == inviteId
        );
        let currentInvite = this.usersGrid.apiEnabledInvites.items.filter(
          (x) => x.inviteId == inviteId
        )[0];
        currentInvite = await this.inviteService.getInviteDetails(inviteId);
        this.usersGrid.apiEnabledInvites.items[currentInviteIndex] = currentInvite;

        if (currentInvite.confirmUserIWSignatureInProgress) {
          setTimeout(() => {
            this.isConfirmUserIWSignatureInProgress(
              inviteId,
              maxRetries,
              msRefreshTime,
              retry++
            );
          }, msRefreshTime);
        }
      }, msRefreshTime);
    }
  }

  confirmUserMessageTooltipTitle(userInvite: Invite) {
    if (userInvite.confirmUserIWSignatureInProgress) {
      return this.translate.instant("usersModule.confirmUserInProgressBody");
    }
    return this.translate.instant("usersModule.confirmUserTitle");
  }

  async editUserClick(userInvite: Invite) {
    const modalRef = this.modalService.open(EditUserComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "lg",
    });
    modalRef.componentInstance.userInvite = userInvite;

    try { await modalRef.result; } catch {}
    this.showSpinner = true;
    await this.loadData(this.options.page, this.options.size);
    this.showSpinner = false;
  }

}
